import { Button, Form, Input, Spin } from "antd";
import React from "react";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { BlueButton } from "@share/components";
import { FormattedMessage, useIntl } from "react-intl";

interface UpdatePasswordProps {
  handleSubmit: (values: FormData) => void;
  resetPassLoading: boolean;
}

const UpdatePassword: React.FC<UpdatePasswordProps> = (props) => {
  const { handleSubmit, resetPassLoading } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  return (
    <div className="card shadow-sm mb-5 border">
      <div className="card-header border-bottom">
        <h4 className="card-header-title">
          <i className="bi bi-shield-lock mx-2"></i><FormattedMessage id="update.password" />
        </h4>
      </div>

      <Spin spinning={resetPassLoading}>
        <Form
          form={form}
          onFinish={handleSubmit}
          className="card-body p-4"
          layout="vertical"
        >
          <Form.Item
            name="currentPassword"
            label={intl.formatMessage({ id: 'current.password' })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: 'enter.current.password' }),
              },
            ]}
            hasFeedback
          >
            <Input.Password
              placeholder={intl.formatMessage({ id: 'enter.current.password.message' })}
              className='form-control form-control-lg'
              style={{display: 'inline-flex'}}
            />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label={intl.formatMessage({ id: 'enter.new.password' })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: 'enter.new.password' }),
              },
            ]}
            hasFeedback
          >
            <Input.Password
              placeholder={intl.formatMessage({ id: 'enter.new.password' })}
              className='form-control form-control-lg'
              style={{display: 'inline-flex'}}
              iconRender={(visible) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
                </div>
              )}
            />
          </Form.Item>
          <Form.Item
            name="confirmNewPassword"
            label={intl.formatMessage({ id: 'confirm.new.password' })}
            dependencies={["newPassword"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: 'confirm.new.password.message' }),
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      intl.formatMessage({ id: "password.do.not.match" })
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder={intl.formatMessage({ id: 'confirm.new.password.message' })}
              className='update-password-input form-control form-control-lg'
              style={{display: 'inline-flex'}}
            />
          </Form.Item>

          <div className="d-flex justify-content-end">
                 <BlueButton
                        block
                        size="large"
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary commonBlueBtn"
                      >
                        <FormattedMessage id="save.changes" />
                </BlueButton>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default UpdatePassword;
